module.exports = __webpack_public_path__ + "img/Google.ee7dcdc9.svg";